<mat-expansion-panel
[expanded]="expandedPanelId === index"
(opened)="onPanelOpened()"
(closed)="onPanelClosed()"
hideToggle
class="category-expansion-panel"
[ngClass]="rowClass"
>
    <mat-expansion-panel-header class="category-expansion-panel__header">
    <mat-panel-title>
        <div class="icon-expansion">
        <mat-icon class="icon-dense">
            {{expandedPanelId !== index ? 'arrow_right' : 'arrow_drop_down'}}
        </mat-icon>
        </div>
        <span class="body-m">{{ 'fragrance-catalogue.product-detail.category' | translate }} {{ dosage.code }}</span>
    </mat-panel-title>
    <mat-panel-description>
        <span class="body-m">{{ dosage.dosage ?? 'N/A' }}</span>
    </mat-panel-description>
    </mat-expansion-panel-header>

    <span class="body-s">
    {{ dosage.description }}
    </span>
</mat-expansion-panel>